<template>
  <div :id="`wrapperAllModerada_${index}`">
    <div class="card-item" :class="{ 'card-item--active': useTarja && item.id_colaboracao === selectedToTarja }">
      <!-- Avatar -->
      <div class="card-item__avatar">
        <v-avatar
          size="48"
          style="cursor: pointer"
          @click="showModalFotoPerfil(item.url_avatar_colaborador)"
        >
          <v-img
            v-if="item.flg_sem_avatar === 'N' && !avatarError"
            :src="item.url_avatar_colaborador"
            alt="Avatar"
            @error="avatarError = true"
          />
          <v-img v-else src="@/assets/User.png" alt="Avatar" />
        </v-avatar>
      </div>

      <!-- Media -->
      <div
        v-if="item.url_midia_colaboracao && item.dsc_tipo_midia_colaboracao !== 'audio'"
        class="card-item__media"
        @click="showModalImagem(item.url_midia_colaboracao, item.dsc_tipo_midia_colaboracao)"
      >
        <template v-if="item.dsc_tipo_midia_colaboracao === 'image'">
          <img
            v-if="!mediaError"
            :src="item.url_midia_colaboracao"
            alt="Imagem colaboração"
            style="width: 100%; height: 120px; object-fit: cover; border-radius: var(--sc-radius-md)"
            @error="mediaError = true"
          />
          <div v-else class="card-item__media-fallback">
            <v-icon size="32" color="text_secondary">mdi-image-off-outline</v-icon>
          </div>
        </template>
        <template v-if="item.dsc_tipo_midia_colaboracao === 'video'">
          <div style="position: relative; width: 100%">
            <v-img
              v-if="!thumbnailError"
              :src="item.url_midia_thumbnail"
              alt="Thumbnail"
              height="120"
              style="border-radius: var(--sc-radius-md)"
              @error="thumbnailError = true"
            >
              <div class="card-item__video-overlay">
                <v-icon size="32">mdi-play-circle-outline</v-icon>
              </div>
              <div v-if="isVideoMetadataLoaded" class="card-item__video-duration">
                {{ timerVideo }}
              </div>
            </v-img>
            <div v-else class="card-item__media-fallback">
              <v-icon size="32" color="text_secondary">mdi-video-off-outline</v-icon>
            </div>
          </div>
        </template>
      </div>

      <!-- Body -->
      <div class="card-item__body">
        <div class="d-flex align-center" style="gap: 6px">
          <span class="card-item__title">{{ item.dsc_nome_colaborador }}</span>
          <v-icon
            v-if="item.flg_colaborador_verificado === 1"
            size="16"
            color="#009DF7"
          >
            mdi-check-decagram
          </v-icon>
        </div>

        <div v-if="hasSubtitleContent" class="card-item__subtitle">
          <a
            v-if="item.dsc_colaborador_user"
            target="_blank"
            rel="noopener"
            :href="userProfileUrl"
          >
            {{ item.dsc_colaborador_user }}
          </a>
          <template v-else>
            <span v-if="item.dsc_uf_colaborador">{{ item.dsc_uf_colaborador }}</span>
            <template v-if="item.dsc_uf_colaborador && (item.dsc_colaborador_phone || item.dsc_colaborador_email || item.dsc_complemento)">
              <span class="meta-separator"> · </span>
            </template>
            <span v-if="item.dsc_colaborador_phone">{{ formatCellPhone(item.dsc_colaborador_phone) }}</span>
            <template v-if="item.dsc_colaborador_phone && (item.dsc_colaborador_email || item.dsc_complemento)">
              <span class="meta-separator"> · </span>
            </template>
            <span v-if="item.dsc_colaborador_email" @click="copyEmailToClipboard" style="cursor: pointer">
              {{ item.dsc_colaborador_email }}
            </span>
            <template v-if="item.dsc_colaborador_email && item.dsc_complemento">
              <span class="meta-separator"> · </span>
            </template>
            <span v-if="item.dsc_complemento" class="card-item__info-inline">
              {{ item.dsc_complemento }}
            </span>
          </template>
        </div>

        <!-- Text -->
        <p
          v-if="Boolean(item.flg_exibir_texto) && item.dsc_texto_colaboracao && item.dsc_texto_colaboracao.length > 0"
          class="card-item__info"
        >
          {{ item.dsc_texto_colaboracao }}
        </p>

        <!-- Audio player -->
        <CardAudioPlayer
          v-if="item.url_midia_colaboracao && item.dsc_tipo_midia_colaboracao === 'audio'"
          :key="item.url_midia_colaboracao"
          :src="item.url_midia_colaboracao"
          flush
        />

        <!-- Meta -->
        <div class="card-item__meta">
          <span class="meta-source">{{ capitalize(item.dsc_fonte_colaboracao) }}</span>
          <span class="meta-separator">·</span>
          <span>{{ formatDate(item.dat_colaboracao) }}</span>
          <span class="meta-separator">·</span>
          <span>{{ formatHour(item.dat_colaboracao) }}</span>
        </div>
      </div>

      <!-- Actions -->
      <div class="card-item__actions">
        <v-tooltip left color="surface_neutral_selected">
          <template v-slot:activator="{ on, attrs }">
            <button
              class="card-action-box card-action-box--delete"
              v-bind="attrs"
              v-on="on"
              @click="removerColaboracaoModerada(item.id_colaboracao, item.cod_producao)"
             aria-label="Remover colaboração moderada">
              <v-icon>mdi-arrow-left</v-icon>
            </button>
          </template>
          <span>Remover colaboração moderada</span>
        </v-tooltip>

        <ModalEditarColaboracao
          :key="`${item.id_colaboracao}-${item.dat_moderacao}`"
          :colaboracaoData="item"
          tipoColaboracao="moderadas"
          :num_coluna_telao="num_coluna_telao"
          :pageModerada="pageModerada"

        />

        <!-- Reorder up -->
        <v-tooltip left color="surface_neutral_selected">
          <template v-slot:activator="{ on, attrs }">
            <button
              class="card-action-box"
              :class="{ 'card-action-box--disabled': !dataModerada || item.num_ordem_colaboracao === dataModerada.totalItems }"
              v-bind="attrs"
              v-on="on"
              @click.prevent="dataModerada && item.num_ordem_colaboracao !== dataModerada.totalItems && ordenarColaboracaoModerada(item.id_colaboracao, item.cod_producao, num_coluna_telao, 'up')"
             aria-label="Reordenar colaboração">
              <v-icon>mdi-chevron-up</v-icon>
            </button>
          </template>
          <span>Reordenar colaboração</span>
        </v-tooltip>

        <!-- Reorder down -->
        <v-tooltip left color="surface_neutral_selected">
          <template v-slot:activator="{ on, attrs }">
            <button
              class="card-action-box"
              :class="{ 'card-action-box--disabled': item.num_ordem_colaboracao === 1 }"
              v-bind="attrs"
              v-on="on"
              @click.prevent="item.num_ordem_colaboracao !== 1 && ordenarColaboracaoModerada(item.id_colaboracao, item.cod_producao, num_coluna_telao, 'down')"
             aria-label="Reordenar colaboração">
              <v-icon>mdi-chevron-down</v-icon>
            </button>
          </template>
          <span>Reordenar colaboração</span>
        </v-tooltip>

        <!-- Column move buttons -->
        <template v-if="colunas && colunas.length > 1">
          <v-tooltip left color="surface_neutral_selected" v-if="coluna_selecionada && num_coluna_telao !== colunas[0].num_coluna_telao">
            <template v-slot:activator="{ on, attrs }">
              <button
                class="card-action-box card-action-box--move"
                v-bind="attrs"
                v-on="on"
                @click="mudarNumColunaTelao(colunas[coluna_selecionada.index - 1].num_coluna_telao, item.id_colaboracao, item.cod_producao, false)"
               aria-label="Mover">
                <v-icon>mdi-arrow-left</v-icon>
              </button>
            </template>
            <span>Mover para {{ colunas[coluna_selecionada?.index - 1]?.dsc_coluna }}</span>
          </v-tooltip>

          <v-tooltip left color="surface_neutral_selected" v-if="coluna_selecionada && num_coluna_telao !== colunas[colunas.length - 1].num_coluna_telao">
            <template v-slot:activator="{ on, attrs }">
              <button
                class="card-action-box card-action-box--move"
                v-bind="attrs"
                v-on="on"
                @click="mudarNumColunaTelao(colunas[coluna_selecionada.index + 1]?.num_coluna_telao, item.id_colaboracao, item.cod_producao, true)"
               aria-label="Mover">
                <v-icon>mdi-arrow-right</v-icon>
              </button>
            </template>
            <span>Mover para {{ colunas[coluna_selecionada?.index + 1]?.dsc_coluna }}</span>
          </v-tooltip>
        </template>

        <MarkAsReadButton
          v-if="$store.state.producoes.selectedProducao && $store.state.producoes.selectedProducao.settings?.mosaico?.enabled"
          :colab-data="item"
          :num_coluna_telao="num_coluna_telao"
          :page-moderada="pageModerada"
          :get-colaboracoes-moderadas="getColaboracoesModeradas"
          :key="item.flg_colaboracao_lida"
        />
      </div>
    </div>

    <!-- Tarja actions row -->
    <div v-if="useTarja" class="card-tarja-actions">
      <ModalExibirNaTarja
        v-if="showTarjaButton"
        :idColaboracao="item.id_colaboracao"
        :codProducao="codProducao"
        @change="changeIsSelectedToTarja(item.id_colaboracao, item.cod_producao, true)"
        :isDisabled="item.dsc_texto_colaboracao.length > 280"
      />
      <ModalExibirNaTarjaFullScreen
        v-if="showFullscreenButton"
        :idColaboracao="item.id_colaboracao"
        :codProducao="item.cod_producao"
        @change="changeIsSelectedToTarja(item.id_colaboracao, item.cod_producao, true)"
        :isDisabled="item.dsc_texto_colaboracao.length > 280"
      />
      <ModalRemoverDaTarja
        v-if="item.id_colaboracao === selectedToTarja"
        @change="changeIsSelectedToTarja(item.id_colaboracao, item.cod_producao, false)"
      />
    </div>

    <!-- Character limit warning -->
    <div
      v-if="useTarja && item.dsc_texto_colaboracao.length > 280"
      class="card-tarja-warning"
    >
      Mensagem muito longa para ser exibida na tarja. Reduza para no máximo 280 caracteres.
    </div>

    <!-- Modals -->
    <ModalExibirFotoPerfil
      :dialog="isModalExibirFotoPerfilVisible"
      :urlFotoPerfil="profile_photo"
      @close="closeModalFotoPerfil"
    />
    <ModalImagem
      :dialog="isModalImagemAprovadasVisible"
      @close="closeModalImagem"
      :midia_url="midia_url_aprovadas"
      :media_type="media_type"
    />
    <ModalConfirmAction
      :visible="showConfirmDialog"
      title="Remover colaboração"
      message="Tem certeza que deseja remover essa colaboração?"
      confirm-text="Remover"
      confirm-color="red"
      @confirm="confirmRemoverColaboracao"
      @cancel="showConfirmDialog = false"
    />
  </div>
</template>

<script>
import ModalImagem from "@/components/Modal/ModalImagem.vue";
import ModalEditarColaboracao from "@/components/Modal/Colaboracao/ModalEditarColaboracao.vue";
import ModalExibirNaTarja from "@/components/Modal/Colaboracao/ModalExibirNaTarja.vue";
import ModalRemoverDaTarja from "@/components/Modal/Colaboracao/ModalRemoverDaTarja.vue";
import ModalExibirFotoPerfil from "@/components/Modal/ModalExibirFotoPerfil.vue";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import { formatDate, formatHour, formatCellPhone } from "@/utils/dateUtils";
import { mapActions, mapGetters } from "vuex";
import ModalExibirNaTarjaFullScreen from "../Modal/Colaboracao/ModalExibirNaTarjaFullScreen.vue";
import MarkAsReadButton from "../Colaboracoes/MarkAsReadButton.vue";
import ModalConfirmAction from "../Modal/ModalConfirmAction.vue";
import CardAudioPlayer from "@/components/Cards/CardAudioPlayer.vue";

export default {
  props: {
    coluna_selecionada: Object,
    colunas: Array,
    item: Object,
    index: Number,
    dataModerada: Object,
    getColaboracoesModeradas: Function,
    getColaboracoesAprovadas: Function,
    selectedToTarja: String,
    num_coluna_telao: Number,
    pageModerada: Number,
    useTarja: [Boolean, String],
    codProducao: Number,
  },
  components: {
    ModalImagem,
    ModalEditarColaboracao,
    ModalExibirNaTarja,
    ModalRemoverDaTarja,
    ModalExibirFotoPerfil,
    ModalExibirNaTarjaFullScreen,
    MarkAsReadButton,
    ModalConfirmAction,
    CardAudioPlayer,
  },
  data() {
    return {
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      isSelectedToTarja: false,
      profile_photo: null,
      isModalExibirFotoPerfilVisible: false,
      timerVideo: null,
      isVideoMetadataLoaded: false,
      showColaboradorPhone: false,
      avatarError: false,
      mediaError: false,
      thumbnailError: false,
      showConfirmDialog: false,
      pendingConfirmAction: null,
      fullscreenProducoes: [
        29, 41, 42, 43, 30, 50, 49, 40, 31, 51, 17, 60, 62, 65, 76, 69, 38, 120, 132, 61,
        134,
      ],
      notFullScreenProducoes: [52],
    };
  },
  mounted() {
    if (
      this.item.url_midia_colaboracao &&
      this.item.dsc_tipo_midia_colaboracao === "video"
    ) {
      const wrapperDiv = document.getElementById(`wrapperAllModerada_${this.index}`);
      const videoElement = document.createElement("video");
      videoElement.setAttribute("src", this.item.url_midia_colaboracao);
      videoElement.setAttribute("id", `video_moderada_${this.index}`);
      videoElement.style.display = "none";
      wrapperDiv.appendChild(videoElement);
      videoElement.onloadedmetadata = () => {
        const duration = videoElement.duration;
        this.timerVideo = new Date(duration * 1000).toISOString().substring(14, 19);
        this.isVideoMetadataLoaded = true;
      };
    }
  },
  computed: {
    ...mapGetters({
      cod_pasta: "pastas/getterCodPasta",
    }),
    userProfileUrl() {
      const user = this.item.dsc_colaborador_user;
      const source = this.item.dsc_fonte_colaboracao;
      if (source === "twitter") return `//${`twitter.com/${user}`}`;
      if (source === "threads") return `//${`threads.net/${user}?hl=pt-br`}`;
      if (source === "bluesky") return `//${`bsky.app/profile/${user.replace("@", "")}`}`;
      return "";
    },
    hasSubtitleContent() {
      return !!(this.item.dsc_colaborador_user || this.item.dsc_uf_colaborador || this.item.dsc_colaborador_phone || this.item.dsc_colaborador_email || this.item.dsc_complemento);
    },
    subtitleText() {
      if (this.showColaboradorPhone && this.item.dsc_colaborador_phone) {
        return formatCellPhone(this.item.dsc_colaborador_phone);
      }
      if (this.item.dsc_uf_colaborador) {
        return this.item.dsc_uf_colaborador;
      }
      if (this.item.dsc_colaborador_email) {
        return this.item.dsc_colaborador_email;
      }
      return null;
    },
    showTarjaButton() {
      if (this.item.id_colaboracao === this.selectedToTarja) return false;
      const cod = this.item.cod_producao;
      const mediaType = this.item.dsc_tipo_midia_colaboracao;
      const hasText = this.item.dsc_texto_colaboracao;

      if ([17, 76].includes(cod) && mediaType === "audio") return true;
      if ([17, 76].includes(cod)) return false;
      if ([29, 38, 120, 61].includes(cod) && ["image", "video"].includes(mediaType)) return false;
      if ([62].includes(cod) && mediaType === "image" && !hasText) return false;
      if ([65].includes(cod) && mediaType === "image" && !hasText) return false;
      return true;
    },
    showFullscreenButton() {
      if (this.item.id_colaboracao === this.selectedToTarja) return false;
      const cod = this.item.cod_producao;
      const mediaType = this.item.dsc_tipo_midia_colaboracao;
      const source = this.item.dsc_fonte_colaboracao;

      if (this.fullscreenProducoes.includes(cod)) {
        if ([29].includes(cod) && ["audio"].includes(mediaType)) return false;
        if ([29].includes(cod) && !this.item.url_midia_colaboracao) return false;
        return true;
      }
      if (source.toLowerCase() === "twitter" && this.notFullScreenProducoes.includes(this.codProducao)) return true;
      if (["image", "video"].includes(mediaType)) return true;
      if ([49, 50, 17, 51, 41, 42, 43, 60, 30, 31, 76].includes(cod)) {
        if ([17, 76].includes(cod) && mediaType === "audio") return false;
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      incrementTotalItems: "colaboracoes_moderadas/incrementTotalItems",
      incrementTotalItemsExibidas: "colaboracoes_aprovadas/incrementTotalItemsExibidas",
      setCopyColaboracoesRecebidas: "colaboracoes_aprovadas/setCopyColaboracoesRecebidas",
    }),
    formatDate,
    formatHour,
    formatCellPhone,
    capitalize(string) {
      return capitalizeString(string);
    },
    copyEmailToClipboard() {
      try {
        navigator.clipboard.writeText(this.item.dsc_colaborador_email);
        this.$toast.info("Email copiado para a área de transferência");
      } catch (error) {
        console.error(error);
        this.$toast.error("Erro ao tentar copiar email");
      }
    },
    handleSubtitleClick() {
      this.showColaboradorPhone = !this.showColaboradorPhone;
    },
    showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },
    showModalFotoPerfil(url_avatar_colaborador) {
      this.isModalExibirFotoPerfilVisible = true;
      this.profile_photo = url_avatar_colaborador;
    },
    closeModalFotoPerfil() {
      this.isModalExibirFotoPerfilVisible = false;
    },
    closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    async changeIsSelectedToTarja(idColaboracao, codProducao, isExibir) {
      try {
        await apiClient.put(`/exibirColaboracaoTarja/${codProducao}`, {
          idColaboracao,
          isExibir,
        });
        await this.getColaboracoesModeradas({
          num_coluna_telao: this.num_coluna_telao,
          page: this.pageModerada,
          size: 5,
          cod_producao: codProducao,
          filtro_texto_moderada: "",
        });
        this.$emit("change", idColaboracao, isExibir);
      } catch (error) {
        console.error(error);
        this.$toast.error("Não foi possível exibir a colaboração moderada na tarja");
      }
    },
    removerColaboracaoModerada(id_colaboracao, cod_producao) {
      this.pendingConfirmAction = { id_colaboracao, cod_producao };
      this.showConfirmDialog = true;
    },
    async confirmRemoverColaboracao() {
      const { id_colaboracao, cod_producao } = this.pendingConfirmAction;
      this.showConfirmDialog = false;
      this.pendingConfirmAction = null;

      const flag = JSON.parse(localStorage.getItem("@socialcam/flg_favorita")) || false;
      const flg_exibida =
        JSON.parse(localStorage.getItem("@socialcam/flg_exibida")) || false;

      if (this.selectedToTarja === this.item.id_colaboracao) {
        localStorage.removeItem("tarjaParams");
        await apiClient.put(`/exibirColaboracaoTarja/${cod_producao}`, {
          idColaboracao: this.item.id_colaboracao,
          isExibir: false,
        });
        this.$emit("change", this.item.id_colaboracao, false);
      }

      try {
        const response = await apiClient.delete(
          `removerColaboracaoModerada/${cod_producao}/${id_colaboracao}/${this.num_coluna_telao}`
        );
        if (response.status === 200) {
          this.incrementTotalItemsExibidas({ value: 1 });
          const pageModeradas = this.$store.state.colaboracoes_moderadas
            .colaboracoes_moderadas[this.num_coluna_telao].currentPage;
          await this.getColaboracoesModeradas({
            num_coluna_telao: this.num_coluna_telao,
            page: pageModeradas,
            size: 5,
            cod_producao: cod_producao,
            filtro_texto_moderada: "",
          });
          const pageAprovadas = flg_exibida
            ? this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_exibidas.currentPage
            : flag
            ? this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_favoritas.currentPage
            : this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas.currentPage;
          await this.getColaboracoesAprovadas({
            page: pageAprovadas,
            size: 5,
            cod_producao,
            flg_favorita: flag,
            flg_exibida,
            cod_pasta: this.cod_pasta,
          });
          this.setCopyColaboracoesRecebidas(
            this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas
          );
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Não foi possível remover colaboração moderada");
      }
    },
    async mudarNumColunaTelao(para_num_coluna_telao, id_colaboracao, cod_producao, incrementar) {
      try {
        const response = await apiClient.patch(
          `/mudarColunaColaboracaoModerada/${cod_producao}`,
          {
            id_colaboracao,
            para_num_coluna_telao,
          }
        );
        if (response.status === 200) {
          await this.getColaboracoesModeradas({
            num_coluna_telao: this.num_coluna_telao,
            page: this.pageModerada,
            size: 5,
            cod_producao,
            filtro_texto_moderada: "",
          });
          await this.incrementTotalItems({ para_num_coluna_telao, incrementar });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async ordenarColaboracaoModerada(id_colaboracao, cod_producao, num_coluna_telao, up_or_down) {
      try {
        const response = await apiClient.patch(
          `/ordenarColaboracaoModerada/${cod_producao}/${id_colaboracao}`,
          { up_or_down }
        );
        if (response.status === 200) {
          await this.getColaboracoesModeradas({
            num_coluna_telao,
            page: this.pageModerada,
            size: 5,
            cod_producao: cod_producao,
            filtro_texto_moderada: "",
          });
        }
      } catch (error) {
        return error;
      }
    },
  },
};
</script>
